import { apiClient } from '@/config/api';

export type PlanningProject = {
  id: number;
  title: string;
  city: string | null;
};

export type PlanningBuilding = {
  id: number;
  name: string | null;
  code: string | null;
};

export type PlanningWeek = {
  mon: (number | null)[];
  tue: (number | null)[];
  wed: (number | null)[];
  thu: (number | null)[];
  fri: (number | null)[];
  sat: (number | null)[];
  sun: (number | null)[];
};

export type PlanningPayload = {
  timezone: string;
  week: PlanningWeek;
};

export type PlanningResponse = {
  building: PlanningBuilding;
  configKey: string;
  planning: PlanningPayload;
};

export const planningService = {
  async getProjects(): Promise<PlanningProject[]> {
    const { data } = await apiClient.get<PlanningProject[]>('/planning/projects');
    return data;
  },

  async getBuildings(projectId: number): Promise<PlanningBuilding[]> {
    const { data } = await apiClient.get<PlanningBuilding[]>(`/planning/projects/${projectId}/buildings`);
    return data;
  },

  async getBuildingPlanning(buildingId: number): Promise<PlanningResponse> {
    const { data } = await apiClient.get<PlanningResponse>(`/planning/buildings/${buildingId}`);
    return data;
  },

  async updateBuildingPlanning(buildingId: number, planning: PlanningPayload): Promise<PlanningResponse> {
    const { data } = await apiClient.put<PlanningResponse>(`/planning/buildings/${buildingId}`, planning);
    return data;
  },
};

